export default "__VITE_ASSET__eew_nl2f__"